require('./angulartics-ga')
module.exports = 'angulartics.google.analytics'



/*****************
 ** WEBPACK FOOTER
 ** ./~/angulartics-google-analytics/lib/index.js
 ** module id = 33
 ** module chunks = 0
 **/